import React, { Suspense } from "react";
import Footer from "./Footer";
import SideNavBarUser from "./SideNavBarUser";
import TopNavBar from "./TopNavBar";
import "../../styles/App.css";
import { useSelector } from "react-redux";
import { StoreState } from "../../redux/reducers";
import { AuthUserType } from "../../redux/actions/authUserActions";
import SideNavBarAdmin from "./SideNavBarAdmin";

interface MainProps {
  children: React.ReactNode;
}

const Main: React.FC<MainProps> = ({ children }) => {
  const authUser = useSelector<StoreState, AuthUserType>(
    (state) => state.authUser,
  );

  return (
    <div className="main-layout">
      <Suspense>
        {authUser.role === "User" ? <SideNavBarUser /> : <SideNavBarAdmin />}
      </Suspense>
      <div className="main-content-wrapper">
        <Suspense>
          <TopNavBar />
        </Suspense>
        <section className="content-section">{children}</section>
        <Suspense>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
};

export default Main;
